import { CSSProperties, SVGProps } from 'react';

import { COLORS } from '../../../lib';

interface Trash2IconProps extends SVGProps<SVGSVGElement> {
  color?: CSSProperties['color'];
}

export const Trash2Icon = ({ color, ...props }: Trash2IconProps) => {
  const fill = color ?? COLORS['icon-brand-500'];

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="19"
      viewBox="0 0 15 19"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.00117 5.84375V14.8438C3.00117 15.8379 3.80706 16.6438 4.80117 16.6438H10.2012C11.1953 16.6438 12.0012 15.8379 12.0012 14.8438V5.84375H13.8012V14.8438C13.8012 16.832 12.1894 18.4438 10.2012 18.4438H4.80117C2.81295 18.4438 1.20117 16.832 1.20117 14.8438V5.84375H3.00117Z"
        fill={fill}
      />
      <path
        d="M5.70078 8.54297C5.20373 8.54297 4.80078 8.94591 4.80078 9.44297V13.043C4.80078 13.54 5.20373 13.943 5.70078 13.943C6.19784 13.943 6.60078 13.54 6.60078 13.043V9.44297C6.60078 8.94591 6.19784 8.54297 5.70078 8.54297Z"
        fill={fill}
      />
      <path
        d="M9.30078 8.54297C8.80373 8.54297 8.40078 8.94591 8.40078 9.44297V13.043C8.40078 13.54 8.80373 13.943 9.30078 13.943C9.79784 13.943 10.2008 13.54 10.2008 13.043V9.44297C10.2008 8.94591 9.79784 8.54297 9.30078 8.54297Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.90078 4.04336V3.14336C3.90078 1.65219 5.10961 0.443359 6.60078 0.443359H8.40078C9.89195 0.443359 11.1008 1.65219 11.1008 3.14336V4.04336H13.8008C14.2978 4.04336 14.7008 4.4463 14.7008 4.94336C14.7008 5.44042 14.2978 5.84336 13.8008 5.84336H1.20078C0.703725 5.84336 0.300781 5.44042 0.300781 4.94336C0.300781 4.4463 0.703725 4.04336 1.20078 4.04336H3.90078ZM5.70078 3.14336C5.70078 2.6463 6.10373 2.24336 6.60078 2.24336H8.40078C8.89784 2.24336 9.30078 2.6463 9.30078 3.14336V4.04336H5.70078V3.14336Z"
        fill={fill}
      />
    </svg>
  );
};
